export const formatCreditRequest = (payload) => {
  const {
    applyEndpoint,
    accountId,
    empId,
    memberNumber: memberId,
    pageTrackingId,
    trackingEnabled,
    trackingReferer,
    requestURL,
  } = payload;

  const body = {
    accountId,
    memberId,
    ...(requestURL && { requestURL }),
    ...(empId && { empId }),
    ...(pageTrackingId && { pageTrackingId }),
    ...(trackingEnabled && { trackingEnabled }),
    ...(trackingReferer && { trackingReferer }),
  };
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  return { applyEndpoint, config };
};

export const applyForCreditAsync = (payload) => {
  const { applyEndpoint, config } = formatCreditRequest(payload);
  return fetch(applyEndpoint, config);
};

export const submitConfirmMembershipFormAsync = ({ url, recaptcha, ...formData }) => {
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      CaptchaResponse: recaptcha,
    },
    body: JSON.stringify(formData),
  };

  return fetch(url, config);
};

export const handleGetUserResponse = (payload = {}) => new Promise((res) => {
  const {
    accountId,
    isLoggedIn,
    membership,
    employeeId = null,
  } = payload;

  let nextContact = null;
  if (payload.contact) {
    nextContact = {
      email: payload.contact.email,
      firstName: payload.contact.firstName,
      lastName: payload.contact.lastName,
    };
  }
  const isSignedIn = !!isLoggedIn;
  const linkedMembershipIsPresent = !!(membership?.memberNumber);
  const memberNumber = membership?.memberNumber || '';

  res({
    contact: nextContact,
    isSignedIn,
    linkedMembershipIsPresent,
    memberNumber,
    accountId,
    employeeId,
  });
});

export const spliceRetrievedUserData = ({
  response,
  fieldsData,
  employeeNumberData,
}) => new Promise((res) => {
  const { contact, memberNumber, employeeId } = response;

  // if there is no contact, no user data exists to be spliced. abort & do not return fieldsData
  if (!contact) res(response);

  const { firstName, lastName } = contact;
  const allDataValid = [firstName, lastName, memberNumber].every((value) => !!value);

  // unless first, last, and memberNumber values exist, abort
  if (!allDataValid) res(response);

  const nextFieldsData = fieldsData.map((field) => {
    const { id } = field;
    let updates = {};
    if (id === 'memberFirstName') {
      updates = { value: firstName, disabled: true };
    } else if (id === 'memberLastName') {
      updates = { value: lastName, disabled: true };
    } else if (id === 'memberId') {
      updates = { value: memberNumber, disabled: true };
    }
    return {
      ...field,
      ...updates,
    };
  });

  // include updated employeeNumberData.value if employeeId is present
  let nextResponse = { ...response };
  if (employeeId) {
    nextResponse = {
      ...nextResponse,
      employeeNumberData: {
        ...employeeNumberData,
        value: employeeId,
      },
      hasEnteredEmployeeNumber: true,
      isOpenEmployeeNumber: false,
    };
  }

  res({
    ...nextResponse,
    fieldsData: nextFieldsData,
  });
});

export const getConfirmMembershipFormData = (fieldsData) => fieldsData
  .reduce((obj, { id, value }) => {
    /* eslint-disable-next-line */
    obj[id] = value;
    return obj;
  }, {});
